import { Component } from '@angular/core';

@Component({
    selector: 'app-mp-additional-information',
    imports: [],
    templateUrl: './mp-additional-information.component.html',
    styleUrl: './mp-additional-information.component.scss'
})
export class MpAdditionalInformationComponent {}